/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/services"/>
import { get, post, put } from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";

import { CompanyConfigurationField, DefaultSupplierEmail, IEligibleForEmailCommunication, IEmailContent, IEmailSettings, IRejectionAction, IReasonCode, ISupplierInvoiceRejectionDto, RejectionEmailContentRequestDto, RejectionManagementCompanyConfiguration, UpdateCompanyConfigurationPayload } from "./interfaces";
import { postMultipart } from "Core/Medius.Core.Web/Scripts/Medius/core/communication/platform";

export function getActiveRejectionManagementReasonCodes(hierarchyId: string): Promise<Array<IReasonCode>> {
    return get(`remedium-api/apa/rejectionManagement/activeReasonCodes?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function getEmailEligibility(documentId: number): Promise<IEligibleForEmailCommunication | null> {
    return get(`remedium-api/apa/rejectionManagement/emailEligibility?documentId=${documentId}`);
}

export async function postISupplierInvoiceRejectionDto(reasonCode: ISupplierInvoiceRejectionDto, attachments?: File[]): Promise<number> {
    const formData = new FormData();
    formData.append('Payload', JSON.stringify(reasonCode));

    if (attachments && attachments.length > 0) {
        attachments.forEach(file => {
            formData.append('Attachments', file);
        });
    }

    return postMultipart("remedium-api/apa/rejectionManagement/reject", formData);
}

export async function getEmailSettings(documentId: number): Promise<IEmailSettings> {
    return get(`remedium-api/apa/rejectionManagement/emailSettings/${documentId}`);
}

export async function getActiveRejectionActions(hierarchyId: string): Promise<IRejectionAction[]> {
    return get(`remedium-api/apa/rejectionAction/activeActions?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function getSelectedReasonCodes(documentId: number): Promise<Array<IReasonCode>> {
    return get(`remedium-api/apa/rejectionManagement/invoices/${documentId}/rejection-reasons`);
}

export async function getRejectionEmailAiContent(documentId: number, rejectionEmailContentRequestDto: RejectionEmailContentRequestDto): Promise<IEmailContent> {
    return post(`remedium-api/apa/rejectionManagement/rejectionEmail/${documentId}`, rejectionEmailContentRequestDto);
}

export async function getDefaultSupplierEmail(documentId: number): Promise<DefaultSupplierEmail> {
    return get(`remedium-api/apa/rejectionManagement/supplier/defaultEmail/${documentId}`);
}

const getMergedUrl = (
    companyId?: number,
    fields: CompanyConfigurationField[] = [],
    includeInheritanceConfiguration: boolean = false
) => {
    const queryParts = fields.map((field) => `fields=${encodeURIComponent(field)}`);

    queryParts.push(`includeInheritanceConfiguration=${includeInheritanceConfiguration}`);

    const queryString = queryParts.join("&");
    const basePath = "remedium-api/apa/rejectionManagement/companyConfiguration/merged";
    const path = companyId !== undefined
        ? `${basePath}/${companyId}`
        : basePath;

    return queryString.length > 0
        ? `${path}?${queryString}`
        : path;
};

export async function getLiteralCompanyConfiguration(companyId: number): Promise<RejectionManagementCompanyConfiguration> {
    return get(`remedium-api/apa/rejectionManagement/companyConfiguration/${companyId}`);
}

export async function getMergedCompanyConfiguration(
    companyId?: number,
    fields?: CompanyConfigurationField[],
    includeInheritanceConfiguration: boolean = false
): Promise<RejectionManagementCompanyConfiguration> {
    return get(getMergedUrl(companyId, fields, includeInheritanceConfiguration));
}

export async function updateCompanyConfiguration(
    companyId: number,
    payload: UpdateCompanyConfigurationPayload
): Promise<void> {
    await put(`remedium-api/apa/rejectionManagement/companyConfiguration/${companyId}`, payload);
}
